import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function CreateCollege () {
  const history = useHistory();
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [values, setValues] = useState({});
  function handleChangeValues (event) {
    setValues({ ...values, [event.target.name]: event.target.value });
  }

  function handleSubmit (event) {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      api.post('/colleges', { name: values.name, realm: values.realm })
        .then(() => {
          setValues({
            name: '',
            realm: '',
          });
          setSuccess(true);
          document.getElementById('msgSuccess').innerHTML = 'Instituição cadastrada com sucesso!';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            document.getElementById('msgError').innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    }
  }
  return (
    <div className="content-register">
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <Card style={{ width: '23rem' }}>
        <Card.Header>
          <h5>Cadastro de Instituição</h5>
        </Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Nome da Instituição</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.name}
                name="name"
                required
                type="text"
                placeholder="Entre com o nome da insituição"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com o nome da insituição
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRealm">
              <Form.Label>Realm</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.realm}
                name="realm"
                required
                type="text"
                placeholder="Entre com o realm"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com o realm
              </Form.Control.Feedback>
            </Form.Group>

            <Button block type="submit" variant="success">Cadastrar</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
